import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const PrivateRoute = ({ allowedRoles, allowedRoleNames }) => {
  const tokenString = localStorage.getItem("token");
  const token = tokenString ? JSON.parse(tokenString) : null;

  const userRoleId = token?.role?.id;
  const userRoleName = (token?.role?.role_name || '').toLowerCase();

  if (!token) {
    return <Navigate to="/login" />;
  }

  const requiresSpecificRole =
    (Array.isArray(allowedRoles) && allowedRoles.length > 0) ||
    (Array.isArray(allowedRoleNames) && allowedRoleNames.length > 0);

  if (!requiresSpecificRole) {
    return <Outlet />;
  }

  const hasAllowedRoleId = Array.isArray(allowedRoles)
    ? allowedRoles.includes(userRoleId)
    : false;

  const normalizedAllowedRoleNames = Array.isArray(allowedRoleNames)
    ? allowedRoleNames.map((roleName) => String(roleName).toLowerCase())
    : [];
  const hasAllowedRoleName = normalizedAllowedRoleNames.includes(userRoleName);

  if (!hasAllowedRoleId && !hasAllowedRoleName) {
    return <Navigate to="/" />;
  }

  return <Outlet />;
};

export default PrivateRoute;
